import React from 'react';
import { Input, RadioGroup, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';
import { StyledDropdown as CheggUiDropdown } from '../Shared/styled';
import { TabHeaders, getCitingOptions, getSourceWasOptions } from '../../forms/magazine-newspaper/constants';
import { useFormikContext } from 'formik';
import { PubMainTypeEnum, PubSuffixTypeEnum, SourceType } from '../../types';

/** magazine and newspaper citing section id and testId */
export var SECTION_ID = 'magazine-citing-section';
export var SECTION_TEST_ID = 'magazine-citing-section-test-id';
export var MAGAZINE_TITLE_INPUT_TEST_ID = 'magazine-title-test-id';

/** radio group options, title for "citing dropdown" and "Source was" field + testIds for that field */
export var MAGAZINE_DROPDOWN_TEST_ID = 'magazine-dropdown-test';
export var SOURCE_WAS_RADIO_INPUT_TITLE = 'Source was';
export var SOURCE_WAS_RADIO_INPUT_TEST_ID = 'source-was-radio-input-test-id';
export var MagazineNewspaperCitingSection = function MagazineNewspaperCitingSection(_ref) {
  var selectedTab = _ref.selectedTab,
    onSourceChange = _ref.onSourceChange,
    source = _ref.source;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var citingOptions = getCitingOptions(source);
  var SourceWasOptions = getSourceWasOptions(source);
  var handleCitationOptionChange = function handleCitationOptionChange(_ref2) {
    var value = _ref2.value;
    if (onSourceChange && (value === SourceType.EDITORIAL || value === SourceType.REVIEW)) {
      onSourceChange(value, {
        main: source === SourceType.MAGAZINE ? PubMainTypeEnum.PUB_MAGAZINE : PubMainTypeEnum.PUB_NEWSPAPER,
        suffix: PubSuffixTypeEnum.PUB_NONE
      });
    }
  };
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, selectedTab === TabHeaders.Online && /*#__PURE__*/React.createElement(RadioGroup, {
    options: SourceWasOptions,
    legend: SOURCE_WAS_RADIO_INPUT_TITLE,
    name: "".concat(selectedTab, ".pubtype.suffix"),
    formikFieldName: 'pubtype.suffix',
    align: "vertical",
    "data-test": SOURCE_WAS_RADIO_INPUT_TEST_ID,
    onChange: function onChange(options) {
      return setFieldValue('pubtype.main', options.main);
    }
  }), /*#__PURE__*/React.createElement(CheggUiDropdown, {
    inputId: "source",
    options: citingOptions,
    value: citingOptions[0].value,
    labelText: 'Source type',
    "data-test": MAGAZINE_DROPDOWN_TEST_ID,
    onSelectValue: function onSelectValue(selectedOption) {
      return handleCitationOptionChange({
        value: selectedOption
      });
    }
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "".concat(source, ".title"),
    labelText: "Article title",
    "data-test": MAGAZINE_TITLE_INPUT_TEST_ID,
    isRecommended: source !== SourceType.MAGAZINE
  }));
};